import { ExpencesActivitiesSchema } from "../types"
import { BottomSection } from "./BottomSection"

interface ExpensesActivitesProps { 
  fixed?: ExpencesActivitiesSchema | null 
  variable?: ExpencesActivitiesSchema | null 
  other?: ExpencesActivitiesSchema | null 
}

export const ExpensesActivites:React.FC<ExpensesActivitesProps> = ({ fixed, variable, other }) => {
  return (
    <div className="mt-5">
        <div className="label-text"><b>EXPENSES ACTIVITIES</b></div>
        <div className="flex overflow-x-auto">
            <BottomSection className="!ml-0 lg:!ml-5" label="FIXED EXPENSES" value={fixed!} />
            <BottomSection label="VARIABLE EXPENSES" value={variable!} />
            <BottomSection label="OTHER EXPENSES" value={other!} />
        </div>
    </div>
  )
}